import React, { useEffect, useState } from 'react';
import { GetAction } from './GetAction';

function YouTubeFeed() {
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadFeed = async () => {
      try {
        const res = await GetAction('get', {}, '/youtube/latestVideos');
        if (mounted && res?.status === 'success') {
          setFeed(res.response);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadFeed();
    return () => {
      mounted = false;
    };
  }, []);

  const videos = feed?.videos || [];
  const channelUrl = feed?.channel_url || 'https://www.youtube.com/@arihanttrust';

  if (!loading && videos.length === 0) {
    return null;
  }

  return (
    <section id="youtube-feed">
      <div className="container">
        <div className="youtube-feed-header">
          <h5 className="text-center font-weight-bold mb-2 heading">यूट्यूब चॅनेल</h5>
          <p className="text-center youtube-feed-subtitle">
            Shree Arihant digambar Jain Trust, Chinchwad — latest videos
          </p>
        </div>

        {loading ? (
          <div className="youtube-feed-loading">Loading videos...</div>
        ) : (
          <>
            <div className="row youtube-feed-grid">
              {videos.map((video) => (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={video.video_id}>
                  <button
                    type="button"
                    className="youtube-feed-card"
                    onClick={() => setActiveVideo(video)}
                    aria-label={`Play ${video.title}`}
                  >
                    <span className="youtube-feed-thumb-wrap">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="youtube-feed-thumb"
                        loading="lazy"
                      />
                      <span className="youtube-feed-play" aria-hidden="true">▶</span>
                    </span>
                    <span className="youtube-feed-meta">
                      <span className="youtube-feed-title">{video.title}</span>
                      {video.published_label ? (
                        <span className="youtube-feed-date">{video.published_label}</span>
                      ) : null}
                    </span>
                  </button>
                </div>
              ))}
            </div>

            <div className="text-center mt-2 mb-4">
              <a
                href={channelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="youtube-feed-channel-btn"
              >
                View full channel on YouTube
              </a>
            </div>
          </>
        )}
      </div>

      {activeVideo ? (
        <div
          className="youtube-feed-modal"
          role="dialog"
          aria-modal="true"
          aria-label="YouTube video player"
          onClick={() => setActiveVideo(null)}
        >
          <div className="youtube-feed-modal-inner" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="youtube-feed-modal-close"
              onClick={() => setActiveVideo(null)}
              aria-label="Close video"
            >
              ×
            </button>
            <div className="youtube-feed-embed-wrap">
              <iframe
                src={`${activeVideo.embed_url}?autoplay=1`}
                title={activeVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <p className="youtube-feed-modal-title">{activeVideo.title}</p>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default YouTubeFeed;
